import { GitCompareArrows } from "lucide-react";
import { STEP_TITLES, fieldsFor } from "./associateSpec";

const human = (k) => k.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

export const ChangesPanel = ({ changes, ctx }) => {
  if (!changes?.length) return null;
  const label = (s, k) => {
    const l = (fieldsFor(s, ctx).find((f) => f.key === k) || {}).label;
    return !l || /^(VALIDITY|PROOF|CERTIFICATE NUMBER|NUMBER|NAME)\b/.test(l) ? human(k) : l;
  };
  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-4" data-testid="associate-changes-panel">
      <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-amber-900">
        <GitCompareArrows className="h-4 w-4" />Changed details awaiting verification ({changes.length})
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[520px] text-left text-xs">
          <thead className="text-[11px] uppercase tracking-wider text-amber-800/80">
            <tr><th className="py-1.5 pr-3">Section</th><th className="py-1.5 pr-3">Field</th><th className="py-1.5 pr-3">Old value</th><th className="py-1.5">New value</th></tr>
          </thead>
          <tbody>
            {changes.map((c, i) => (
              <tr key={`${c.step}-${c.field}`} className="border-t border-amber-200/70 align-top" data-testid={`associate-change-row-${i}`}>
                <td className="py-1.5 pr-3 text-slate-600">{STEP_TITLES[c.step] || c.step}</td>
                <td className="py-1.5 pr-3 font-medium text-slate-800">{label(c.step, c.field)}</td>
                <td className="break-all py-1.5 pr-3 text-rose-700 line-through decoration-rose-300">{c.old || "—"}</td>
                <td className="break-all py-1.5 font-semibold text-emerald-700">{c.new || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
